import { mediaSrc } from "../lib/media";
import { ExternalLink, Play } from "lucide-react";

export function MediaGallery({ media = [], className = "" }) {
  if (!media || media.length === 0) return null;
  return (
    <div className={`grid gap-2 ${media.length === 1 ? "grid-cols-1" : "grid-cols-2"} ${className}`} data-testid="media-gallery">
      {media.map((m, idx) => {
        const src = mediaSrc(m.url);
        const isExternalEmbed = /youtube|youtu\.be|vimeo/i.test(m.url);
        if (m.type === "video" && isExternalEmbed) {
          return (
            <a
              key={m.url || idx}
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="relative flex items-center justify-center bg-ink text-white rounded-lg aspect-video hover:opacity-90 transition-opacity"
            >
              <Play className="w-10 h-10" />
              <span className="absolute bottom-2 right-2 text-xs inline-flex items-center gap-1 bg-white/15 px-2 py-1 rounded">
                Watch <ExternalLink className="w-3 h-3" />
              </span>
            </a>
          );
        }
        if (m.type === "video") {
          return (
            <video key={m.url || idx} src={src} controls preload="metadata" className="w-full rounded-lg bg-black aspect-video object-contain" />
          );
        }
        return (
          <img key={m.url || idx} src={src} alt="" loading="lazy" className="w-full rounded-lg object-cover max-h-80" />
        );
      })}
    </div>
  );
}
